const defaultCategories = {
    "Apparel and Accessories": {
        "label": "Apparel and Accessories",
        "display": true,
        "types": {
            "Activewear Store": "Active sports clothing",
            "Beauty Supply Store": "Beauty Supply",
            "Bridal Shop": "Bridal",
            "Clothing Accessories Store": "Clothing Accessories",
            "Jewelry Store": "Jewelry",
            "Leather Goods Store": "Leather Goods",
            "Lingerie Store": "Lingerie",
            "Logo Apparel": "Logo Apparel",
            "Maternity Wear Store": "Maternity Wear",
            "Men's Clothing Store": "Men's Clothing",
            "Optician or Eyeglasses Store": "Optician or Eyeglasses",
            "Outdoor Clothing Store": "Outdoor Clothing",
            "Perfume Store": "Perfume",
            "Personal Shopper": "Personal Shopper",
            "Shoe Store": "Shoe",
            "Sportswear Store": "Sportswear",
            "Swimwear Store": "Swimwear",
            "Watch Store": "Watch",
            "Western Wear Store": "Western Clothing",
            "Women's Clothing Store": "Women's Clothing"
        }
    },
    "Arts and Entertainment": {
        "label": "Arts and Entertainment",
        "display": true,
        "types": {
            "Arcade": "Arcade",
            "Arts & Crafts Show": "Arts & Crafts Show",
            "Beer Festival": "Beer Festival",
            "Bingo Hall": "Bingo Hall",
            "Car Show": "Car Show",
            "Casino": "Casino",
            "Community Theatre": "Community Theatre",
            "Food Festival": "Food Festival",
            "Live Theater": "Live Theater",
            "Motorsport Racetrack": "Motorsport Racetrack",
            "Movie Theater": "Movie Theater",
            "Museum": "Museum",
            "Music Festival": "Music Festival",
            "Performing Arts Center": "Performing Arts Center",
            "Psychic or Astrologer": "Psychic or Astrologer",
            "Social Club": "Social Club",
            "Stadium or Arena": "Stadium or Arena",
            "Wine Festival": "Wine Festival",
            "Wine Tour": "Wine Tour"
        }
    },
    "Automotive": {
        "label": "Automotive",
        "display": true,
        "types": {
            "Auto Battery Store": "Auto Battery",
            "Auto Body Shop": "Auto Body",
            "Auto Detailing Shop": "Auto Detailing",
            "Auto Glass Repair Shop": "Auto Glass Repair",
            "Auto Parts Store": "Auto Parts",
            "Auto Repair Shop": "Auto Repair",
            "Auto Salvage Yard": "Auto Salvage Yard",
            "Auto Stereo Installation": "Auto Stereo Installation",
            "Auto Towing Service": "Auto Towing",
            "Auto Window Tinting": "Auto Window Tinting",
            "Car Audio Store": "Car Audio",
            "Car Wash": "Car Wash",
            "Commercial Truck Dealership": "Commercial Truck Dealership",
            "Gas Station": "Gas Station",
            "New Vehicle Dealership": "New Vehicle Dealership",
            "Oil Change Station": "Oil Change Station",
            "Parking Garage": "Parking Garage",
            "Pick and Pull Lot": "Pick and Pull Lot",
            "Recreation Vehicle (RV) Dealership": "Recreation Vehicle (RV) Dealership",
            "Smog Check Station": "Smog Check Station",
            "Tire Store": "Tire",
            "Used Vehicle Dealership": "Used Vehicle Dealership"
        }
    },
    "Beauty and Spa": {
        "label": "Beauty and Spa",
        "display": true,
        "types": {
            "Barbershop": "Barber",
            "Day Spa": "Day Spa",
            "Eyelash Extension Salon": "Eyelash Extension Salon",
            "Hair Removal Salon": "Hair Removal Salon",
            "Hair and Beauty Salon": "Hair and Beauty Salon",
            "Makeup Artist": "Makeup Artist",
            "Massage": "Massage",
            "Nail Salon": "Nail Salon",
            "Piercing Studio": "Piercing Studio",
            "Skin Care Store": "Skin Care",
            "Tanning Salon": "Tanning Salon",
            "Tattoo Studio": "Tattoo Studio"
        }
    },
    "Child Related Businesses": {
        "label": "Child Related Businesses",
        "display": true,
        "types": {
            "Childcare or Daycare": "Childcare or Daycare",
            "Children's Clothing Store": "Children's Clothing",
            "Children's Party Entertainment": "Children's Party Entertainment",
            "Children's Shoe Store": "Children's Shoe",
            "Party Planning": "Party Planning",
            "Sports Camp": "Sports Camp",
            "Summer Camp": "Summer Camp"
        }
    },
    "Community and State Services": {
        "label": "Community and State Services",
        "display": true,
        "types": {
            "Chamber of Commerce": "Chamber of Commerce",
            "Charity or Philanthropic Organization": "Charity or Philanthropic Organization",
            "Church": "Church",
            "City or Municipal Service": "City or Municipal",
            "Community Service or Non-Profit Organization": "Community or Non-Profit Organization",
            "Mosque": "Mosque",
            "Temple": "Temple"
        }
    },
    "Education": {
        "label": "Education",
        "display": true,
        "types": {
            "Art School": "Art School",
            "Beauty School": "Beauty School",
            "Charter School": "Charter School",
            "Community College": "Community College",
            "Continuing Education Courses": "Continuing Education Courses",
            "Culinary School": "Culinary School",
            "Dance School": "Dance School",
            "Driving School": "Driving School",
            "Elementary School": "Elementary School",
            "Graduate school": "Graduate school",
            "Language School": "Language School",
            "Lecture or Seminar Series": "Lecture or Seminar Series",
            "Middle School or High School": "Middle School or High School",
            "Musical Instruments and Lessons": "Musical Instruments and Lessons",
            "Parochial School": "Parochial School",
            "Preschool": "Preschool",
            "Private Elementary School": "Private Elementary School",
            "Private High School": "Private High School",
            "Private K-12 School": "Private K-12 School",
            "Private Middle School": "Private Middle School",
            "Private Tutor": "Private Tutor",
            "Tutoring Center": "Tutoring Center",
            "University": "University",
            "Vocational School": "Vocational School"
        }
    },
    "Event Planning and Services": {
        "label": "Event Planning and Services",
        "display": true,
        "types": {
            "Announcement Printing Service": "Announcement Printing",
            "Boat Charter": "Boat Charter",
            "Card or Stationery Store": "Card or Stationery",
            "Catering Service": "Catering",
            "Disc Jockey (DJ)": "Disc Jockey (DJ)",
            "Event Coordinator": "Event Coordinator",
            "Event Space or Venue": "Event Space or Venue",
            "Hotel Meeting Room or Event Space": "Hotel Meeting Room or Event Space",
            "Musician or Band": "Musician or Band",
            "Party Supply Store": "Party Supply",
            "Personal Chef": "Personal Chef",
            "Photographer": "Photographer",
            "Videographer": "Videographer",
            "Wedding Planner": "Wedding Planner",
            "Wedding Venue or Banquet Hall": "Wedding Venue or Banquet Hall"
        }
    },
    "Family Activity": {
        "label": "Family Activity",
        "display": true,
        "types": {
            "Amusement Park": "Amusement Park",
            "Aquarium": "Aquarium",
            "Athletic Club": "Athletic Club",
            "Family Entertainment Center": "Family Entertainment Center",
            "Family Play Center": "Family Play Center",
            "Go Kart Track": "Go Kart Track",
            "Horseback Riding": "Horseback Riding",
            "Ice Skating Rink": "Ice Skating Rink",
            "Local Sports Team": "Local Sports Team",
            "Outdoor Park": "Outdoor Park",
            "Playground": "Playground",
            "Professional Sports Team": "Professional Sports Team",
            "Roller Skating Rink": "Roller Skating Rink",
            "Zoo": "Zoo"
        }
    },
    "Farm Equipment and Agriculture Businesses": {
        "label": "Farm Equipment and Agriculture Businesses",
        "display": true,
        "types": {
            "Agriculture Farm Supply Store": "Agriculture Farm ",
            "Farm Equipment Repair Shop": "Farm Equipment Repair",
            "Farm Truck and Tractor Repair Shop": "Farm Truck and Tractor Repair",
            "Large Farming Equipment Dealer": "Large Farming Equipment",
            "Large Farming Equipment Repair Shop": "Large Farming Equipment Repair",
            "New Farm Equipment Dealer": "New Farm Equipment",
            "Used Farm Equipment Dealer": "Used Farm Equipment"
        }
    },
    "Financial Services": {
        "label": "Financial Services",
        "display": true,
        "types": {
            "Bank": "Bank",
            "Check Cashing Service": "Check Cashing",
            "Credit Repair Service": "Credit Repair",
            "Credit Union": "Credit Union",
            "Debt Consolidation Company": "Debt Consolidation",
            "Financial Advisor": "Financial Advisor",
            "Money Transfer Service": "Money Transfer",
            "Payday Loan Company": "Payday Loan",
            "Stockbroker": "Stockbroker",
            "Title Loan Company": "Title Loan"
        }
    },
    "Fitness Businesses or Providers": {
        "label": "Fitness Businesses or Providers",
        "display": true,
        "types": {
            "Barre Studio": "Barre Studio",
            "Boxing Gym": "Boxing Gym",
            "CrossFit Gym": "CrossFit Gym",
            "Dance Studio": "Dance Studio",
            "Exercise Classes": "Exercise Classes",
            "Fitness Boot Camp": "Fitness Boot Camp",
            "Gym, Fitness or Athletic Club": "Gym, Fitness or Athletic Club",
            "Martial Arts Studio": "Martial Arts Studio",
            "Personal Trainer": "Personal Trainer",
            "Pilates Studio": "Pilates Studio",
            "Rock Climbing Gym": "Rock Climbing Gym",
            "Sports Massage Therapist": "Sports Massage Therapist",
            "Swimming Lessons": "Swimming Lessons",
            "Yoga Studio": "Yoga Studio"
        }
    },
    "General Retail": {
        "label": "General Retail",
        "display": true,
        "types": {
            "Adult Video or Adult Store": "Adult Video",
            "Art Gallery": "Art Gallery",
            "Art Supply Store": "Art Supply",
            "Bead Store": "Bead",
            "Blown Glass Gallery": "Blown Glass Gallery",
            "Bookstore": "Book",
            "Camera Store": "Camera",
            "Candle Shop": "Candle",
            "Cargo Trailer Dealer": "Cargo Trailer Dealer",
            "Coin Shop": "Coin",
            "Comic Book Shop": "Comic Book",
            "Compounding Pharmacy": "Compounding Pharmacy",
            "Computer Store": "Computer",
            "Consignment Shop": "Consignment",
            "Costume Store": "Costume",
            "Craft Supply Store": "Craft",
            "Department Store": "Department Store",
            "Discount Store": "Discount",
            "Discount Tobacco Store": "Discount Tobacco",
            "Drugstore or Pharmacy": "Drug or Pharmacy",
            "Electronics Store": "Electronics",
            "Equipment Rental Store": "Equipment Rental",
            "Fabric Store": "Fabric",
            "Firewood Seller": "Firewood Seller",
            "Fireworks Store": "Fireworks",
            "Flag Store": "Flag",
            "Flea Market": "Flea Market",
            "Florist": "Florist",
            "Gift Shop": "Gift",
            "Herb Shop or Herbalist": "Herb or Herbalist",
            "Hobby Shop": "Hobby",
            "Home and Office Battery Store": "Home and Office Battery ",
            "Ink Cartridge Store": "Ink Cartridge",
            "Knife Store": "Knife",
            "Magazine Store": "Magazine",
            "Marijuana Dispensary": "Marijuana Dispensary",
            "Metaphysical Shop": "Metaphysical",
            "Military Surplus Store": "Military Surplus",
            "Mobile Phone Store": "Mobile Phone",
            "Monument or Memorial Company": "Monument or Memorial Company",
            "Music Instrument Store": "Music Instrument",
            "Music Store": "Music",
            "Music and Video Store": "Music and Video",
            "New Age Book Store": "New Age Book",
            "Office Equipment & Supply Store": "Office Equipment",
            "Outlet Store": "Outlet",
            "Pawn Shop": "Pawn",
            "Quilt Shop": "Quilt",
            "Record Store": "Record",
            "Religious Supply or Gift Shop": "Religious Supply or Gift",
            "Safe Company": "Safe Company",
            "Scrap Metal Dealer": "Scrap Metal Dealer",
            "Sewing Studio": "Sewing Studio",
            "Shopping Center": "ping Center",
            "Sign Store": "Sign",
            "Stamp Shop": "Stamp",
            "Survival Store": "Survival",
            "Thrift Store": "Thrift",
            "Tobacco Store": "Tobacco",
            "Toy Store": "Toy",
            "Trophy or Award Store": "Trophy or Award",
            "Vape or Smoke Shop": "Vape or Smoke",
            "Video or Game Rental Store": "Video or Game Rental",
            "Vitamin or Supplement Store": "Vitamin or Supplement",
            "Wedding Supply Store": "Wedding Supply",
            "Wholesale, Warehouse or Club Store": "Wholesale, Warehouse or Club",
            "Wood Carving Shop": "Wood Carving",
            "Yard Equipment Store": "Yard Equipment",
            "Yarn or Knitting Supply Store": "Yarn or Knitting"
        }
    },
    "Grocery / Market": {
        "label": "Grocery / Market",
        "display": true,
        "types": {
            "Farmers Market": "Farmers Market",
            "Grocery Store (Co-op)": "Grocery (Co-op)",
            "Health Food Store": "Health Food",
            "Neighborhood Grocery Store": "Neighborhood Grocery "
        }
    },
    "Health and Medical": {
        "label": "Health and Medical",
        "display": true,
        "types": {
            "55+ Housing Community": "55+ Housing Community",
            "Acupuncturist": "Acupuncturist",
            "Adult Day Care": "Adult Day Care",
            "Allergy or Asthma Specialist": "Allergy or Asthma Specialist",
            "Alzheimer or Memory Care Facility": "Alzheimer or Memory Care ",
            "Assisted Living Facility": "Assisted Living",
            "Audiology Clinic": "Audiology Clinic",
            "Cardiologist": "Cardiologist",
            "Cardiovascular Surgeon": "Cardiovascular Surgeon",
            "Chiropractor": "Chiropractor",
            "Cosmetic Dentist": "Cosmetic Dentist",
            "Cosmetic or Plastic Surgeon": "Cosmetic or Plastic Surgeon",
            "Dental Clinic": "Dental Clinic",
            "Dentist": "Dentist",
            "Denture or Implant Specialist": "Denture or Implant Specialist",
            "Dermatologist": "Dermatologist",
            "Diabetes Specialist": "Diabetes Specialist",
            "Ear, Nose & Throat Doctor": "Ear, Nose & Throat Doctor",
            "Erectile Dysfunction Specialist": "Erectile Dysfunction Specialist",
            "Family Practitioner": "Family Practitioner",
            "Gastroenterologist": "Gastroenterologist",
            "General Practitioner": "General Practitioner",
            "Geriatric Physician": "Geriatric Physician",
            "Hearing Aid Center": "Hearing Aid Center",
            "Home Health Care Provider": "Home Health Care Provider",
            "Hospital": "Hospital",
            "Internal Medicine Doctor": "Internal Medicine Doctor",
            "Laboratory or Medical Testing Facility": "Laboratory or Medical Testing Facility",
            "Laser Eye Surgery Clinic": "Laser Eye Surgery Clinic",
            "Medical Clinic": "Medical Clinic",
            "Medical Hypnotist": "Medical Hypnotist",
            "Medical Imaging Service": "Medical Imaging",
            "Medical Marijuana Authorization": "Medical Marijuana Authorization",
            "Medical Marijuana Dispensary": "Medical Marijuana Dispensary",
            "Medical Spa": "Medical Spa",
            "Medical Supply Store": "Medical Supply",
            "Medical Walk-In Clinic": "Medical Walk-In Clinic",
            "Memory Care Facility": "Memory Care Facility",
            "Mental Health Provider": "Mental Health Provider",
            "Midwifery Service": "Midwifery",
            "Naturopathic Practitioner": "Naturopathic Practitioner",
            "Neurosurgeon": "Neurosurgeon",
            "Nutritionist or Dietician": "Nutritionist or Dietician",
            "Obstetrician & Gynecologist": "Obstetrician & Gynecologist",
            "Oncologist": "Oncologist",
            "Ophthalmologist": "Ophthalmologist",
            "Optometrist": "Optometrist",
            "Oral Surgeon": "Oral Surgeon",
            "Orthodontist": "Orthodontist",
            "Orthopedist": "Orthopedist",
            "Pain Clinic": "Pain Clinic",
            "Pediatrician": "Pediatrician",
            "Physical Health Center": "Physical Health Center",
            "Physical Therapist": "Physical Therapist",
            "Plasma Center": "Plasma Center",
            "Podiatrist": "Podiatrist",
            "Psychiatrist": "Psychiatrist",
            "Rehabilitation Clinic": "Rehabilitation Clinic",
            "Respite Relief Provider": "Respite Relief Provider",
            "Retirement Counselor": "Retirement Counselor",
            "Retirement Home": "Retirement Home",
            "Senior Care Placement Agency": "Senior Care Placement Agency",
            "Senior Center": "Senior Center",
            "Sleep Disorder Clinic": "Sleep Disorder Clinic",
            "Spine Specialist": "Spine Specialist",
            "Sports Medicine Clinic": "Sports Medicine Clinic",
            "Substance Abuse Rehabilitation Clinic": "Substance Abuse Rehabilitation Clinic",
            "Surgical Clinic": "Surgical Clinic",
            "Surgical Specialist": "Surgical Specialist",
            "Urgent Care Clinic": "Urgent Care Clinic",
            "Urologist": "Urologist",
            "Vascular Surgeon or Vein Center": "Vascular Surgeon or Vein Center",
            "Weight Loss Service": "Weight Loss "
        }
    },
    "Home Service Businesses": {
        "label": "Home Service Businesses",
        "display": true,
        "types": {
            "Arborist": "Arborist",
            "Awning & Tent Company": "Awning Tent",
            "Bathtub Refinishing Service": "Bathtub Refinishing",
            "Cabinet Refacing Service": "Cabinet Refacing",
            "Carpet Cleaning Service": "Carpet Cleaning",
            "Chimney Cleaning Service": "Chimney Cleaning",
            "Fuel or Oil Home Heating Service": "Fuel or Oil Home Heating",
            "Furnace Cleaning Service": "Furnace Cleaning",
            "Furniture Upholstery Service": "Furniture Upholstery",
            "Garbage Collection Service": "Garbage Collection",
            "Home Gardening Service": "Home Gardening",
            "Home Pressure Washing Service": "Home Pressure Washing",
            "Home Theater Installation Service": "Home Theater Installation",
            "Home Window Cleaning Service": "Home Window Cleaning",
            "House Cleaning Service": "House Cleaning",
            "Interior Designer": "Interior Designer",
            "Key or Locksmith Service": "Key or Locksmith",
            "Landscaper": "Landscaper",
            "Mold Inspection or Remediation Service": "Mold Inspection or Remediation",
            "Pest Control Service or Exterminator": "Pest Control or Exterminator",
            "Pool Cleaning Service": "Pool Cleaning",
            "Shades & Blinds Installation Service": "Shades & Blinds Installation",
            "Television or Internet Service Provider": "Television or Internet Provider",
            "Wallcoverings Store": "Wallcoverings",
            "Water Treatment Supply & Service": "Water Treatment Supply &",
            "Window & Door Installation": "Window & Door Installation",
            "Air Duct Cleaning Service": "Air Duct Cleaning",
            "Alternative Energy Service": "Alternative Energy",
            "Appliance Repair Service": "Appliance Repair",
            "Asphalt or Paving Contractor": "Asphalt or Paving",
            "Barn or Specialty Building Contractor": "Barn or Specialty Building",
            "Carpenter or Woodworker": "Carpenter or Woodworker",
            "Carpet Installation Contractor": "Carpet Installation",
            "Concrete Contractor": "Concrete",
            "Drywall Installation or Repair Contractor": "Drywall Installation or Repair",
            "Electrician": "Electrician",
            "Excavation Contractor": "Excavation",
            "Fencing Contractor": "Fencing",
            "Fire & Water Damage Restoration Service": "Fire & Water Damage Restoration",
            "Flooring Installation Service": "Flooring Installation",
            "Furnace Contractor": "Furnace",
            "Garage Builder": "Garage Builder",
            "Garage Door Contractor": "Garage Door",
            "General Contractor": "General",
            "Gutter Installation or Repair Contractor": "Gutter Installation or Repair",
            "Handyman": "Handyman",
            "Heating & Air Conditioning Services": "Heating & Air Conditioning",
            "Home Maintenance Service": "Home Maintenance",
            "Home Security Company": "Home Security",
            "Insulation Installer": "Insulation Installer",
            "Junk Removal or Hauling Service": "Junk Removal  Hauling",
            "Kitchen or Bath Remodeling Company": "Kitchen  Bath Remodeling",
            "Landscape Architect": "Landscape Architect",
            "Landscaping Service": "Landscaping",
            "Mover or Moving Company": "Moving",
            "New Home Builder": "New Home Builder",
            "Painting Contractor": "Painting",
            "Plumber or Plumbing Contractor": "Plumbing",
            "Remodeling Contractor": "Remodeling",
            "Roofing Contractor": "Roofing",
            "Septic Tank Contractor": "Septic Tank",
            "Siding Installation or Repair Contractor": "Siding Installation Repair",
            "Solar Energy Contractor": "Solar Energy",
            "Stone or Marble Company": "Stone or Marble Company",
            "Stucco or Plastering Contractor": "Stucco or Plastering",
            "Tile Contractor": "Tile",
            "Water Well Drilling Contractor": "Water Well Drilling",
            "Waterproofing Contractor": "Waterproofing",
            "Wood Milling Shop": "Wood Milling",
            "Wrecking Contractor": "Wrecking",
            "Yard Equipment Repair Service": "Yard Equipment Repair "
        }
    },
    "Home and Garden": {
        "label": "Home and Garden",
        "display": true,
        "types": {
            "Antique Store": "Antique",
            "Baby Supply & Furniture Store": "Baby  Furniture",
            "Bath & Accessory Store": "Bath & Accessory",
            "Building Supply Store or Lumber Yard": "Building Supply  Lumber Yard",
            "Cabinet Store": "Cabinet",
            "Carpet Store": "Carpet",
            "Clock Shop": "Clock",
            "Fireplace, Wood Stove or Barbeque Store": "Fireplace, Wood Stove or Barbeque",
            "Flooring Store": "Flooring",
            "Frame Shop": "Frame",
            "Furniture Store": "Furniture",
            "Hardware Store": "Hardware",
            "Home & Garden Store": "Home & Garden",
            "Home Decor Store": "Home Decor",
            "Hot Tub or Spa Dealer": "Hot Tub Spa Dealer",
            "Hydroponics Store": "Hydroponics",
            "Kitchen Supply Store": "Kitchen",
            "Lighting Store": "Lighting",
            "Major Appliance Store": "Major Appliance",
            "Mattress or Bedding Store": "Mattress Bedding",
            "Outdoor Furniture Store": "Outdoor Furniture",
            "Paint Store": "Paint",
            "Plant Nursery & Garden Supply Store": "Plant Nursery & Garden",
            "Pool & Spa Dealer": "Pool & Spa Dealer",
            "Rent-to-Own Store": "Rent-to-Own",
            "Rug Store": "Rug",
            "Small Appliance Store": "Small Appliance",
            "Solar Energy Equipment Dealer": "Solar Energy Equipment Dealer",
            "TV & Appliance Store": "TV Appliance",
            "TV Store": "TV",
            "Tool Rental Center": "Tool Rental Center",
            "Tool Repair Service": "Tool Repair",
            "Tool Store": "Tool",
            "Vacuum Store": "Vacuum",
            "Wallpaper Store": "Wallpaper",
            "Window Store": "Window "
        }
    },
    "Hotel and Travel": {
        "label": "Hotel and Travel",
        "display": true,
        "types": {
            "Airline": "Airline",
            "Bed & Breakfast": "Bed & Breakfast",
            "Campground": "Campground",
            "Car Rental Company": "Car Rental",
            "Cruise Line": "Cruise Line",
            "Guesthouse": "Guesthouse",
            "Hotel or Motel (Local)": "Hotel Motel (Local)",
            "Hotel or Motel (Out-of-Town)": "Hotel Motel",
            "Limo Service": "Limo",
            "Luggage-Travel Store": "Luggage-Travel",
            "RV Park": "RV Park",
            "RV Rental Company": "RV Rental",
            "Regional Airport": "Regional Airport",
            "Shuttle Service": "Shuttle",
            "Ski Resort": "Ski Resort",
            "Taxi Service": "Taxi",
            "Tour Company": "Tour",
            "Travel Agent": "Travel Agent"
        }
    },
    "Local Services": {
        "label": "Local Services",
        "display": true,
        "types": {
            "Auction House": "Auction House",
            "Bottled Water Delivery Service": "Bottled Water Delivery",
            "Courier or Delivery Service": "Courier  Delivery",
            "Cremation Service Provider": "Cremation Provider",
            "Dry Cleaning or Laundry Service": "Dry Cleaning Laundry",
            "Electronics Repair Shop": "Electronics Repair",
            "Funeral Service Provider": "Funeral",
            "Garage Rental Service": "Garage Rental",
            "General Transportation Service": "General Transportation",
            "Industrial Repair Service": "Industrial Repair",
            "Information Technology (IT) Service": "Information Technology (IT)",
            "Jewelry Repair Shop": "Jewelry Repair",
            "Junkyard": "Junkyard",
            "Mail Store": "Mail",
            "Metal Yard": "Metal Yard",
            "Mobile or Cell Phone Repair Shop": "Mobile or Cell Phone Repair",
            "Moving Trailer Rental Company": "Moving Trailer Rental",
            "Moving Truck Rental Company": "Moving Truck Rental",
            "Music Instrument Rental Shop": "Music Instrument Rental",
            "Printing Service": "Printing",
            "Propane Dealer": "Propane Dealer",
            "Recycling Center": "Recycling Center",
            "Self-Storage Facility": "Self-Storage",
            "Sewing and Alterations Shop": "Sewing and Alterations",
            "Shipping Center": "Shipping Center",
            "Shoe Repair Shop": "Shoe Repair",
            "Small Engine Repair Shop": "Small Engine Repair",
            "Watch or Clock Repair Shop": "Watch  Clock Repair "
        }
    },
    "Medical Service Providers": {
        "label": "Medical Service Providers",
        "display": true,
        "types": {
            "Acupuncture": "Acupuncture",
            "Alternative Care Provider": "Alternative Care",
            "Audiologist": "Audiologist",
            "Chiropractor": "Chiropractor",
            "Counseling & Mental Health Specialist": "Counseling Mental Health Specialist",
            "Dentist": "Dentist",
            "Drugstore or Pharmacy": "Drug  Pharmacy",
            "Family Practice Doctor": "Family Practice Doctor",
            "Hearing Aid Center": "Hearing Aid Center",
            "Home Healthcare": "Home Healthcare",
            "Hospital": "Hospital",
            "Medical Clinic": "Medical Clinic",
            "Optometrist": "Optometrist",
            "Pediatric Dentist": "Pediatric Dentist",
            "Pediatrician": "Pediatrician",
            "Physical Therapy or Rehabilitation service provider": "Physical Therapy Rehabilitation",
            "Primary Care Provider": "Primary Care",
            "Weight Loss Service": "Weight Loss",
            "Wellness Business": "Wellness"
        }
    },
    "Motorsport Businesses": {
        "label": "Motorsport Businesses",
        "display": true,
        "types": {
            "All-Terrain Vehicle (ATV) Dealer": "All-Terrain Vehicle (ATV) Dealer",
            "Boat Dealer": "Boat Dealer",
            "Boat Repair Shop": "Boat Repair",
            "Boat and RV Storage Facility": "Boat RV Storage",
            "Boating Accessory Store": "Boating Accessory",
            "Golf Cart Dealer": "Golf Cart Dealer",
            "Golf Cart Service Center": "Golf Cart Center",
            "Motorcycle Accessory Store": "Motorcycle Accessory",
            "Motorcycle Dealer": "Motorcycle Dealer",
            "Motorcycle Part Store": "Motorcycle Part",
            "Motorcycle Repair Shop": "Motorcycle Repair",
            "Watercraft Dealer": "Watercraft Dealer"
        }
    },
    "Nightlife": {
        "label": "Nightlife",
        "display": true,
        "types": {
            "Adult Club or Entertainment Company": "Adult Club Entertainment",
            "Bar, Lounge or Pub": "Bar, Lounge or Pub",
            "Billiard Hall": "Billiard Hall",
            "Blues Club": "Blues Club",
            "Comedy Club": "Comedy Club",
            "Dancing or Night Club": "Dancing Night Club",
            "Hookah Lounge": "Hookah Lounge",
            "Jazz Club": "Jazz Club",
            "Karaoke Bar": "Karaoke Bar",
            "Music or Concert Hall": "Music Concert Hall",
            "Rock and Roll Club": "Rock and Roll Club",
            "Sports Bar": "Sports Bar",
            "Wine Bar": "Wine Bar"
        }
    },
    "Pet / Animal": {
        "label": "Pet / Animal",
        "display": true,
        "types": {
            "Animal Daycare": "Animal Daycare",
            "Animal Shelter": "Animal Shelter",
            "Bird Seed Store": "Bird Seed",
            "Bird Specialty Store": "Bird Specialty",
            "Emergency Animal Hospital": "Emergency Animal Hospital",
            "Fish or Aquarium Store": "Fish or Aquarium",
            "Pet Boarding": "Pet Boarding",
            "Pet Boutique": "Pet Boutique",
            "Pet Breeder": "Pet Breeder",
            "Pet Groomer": "Pet Groomer",
            "Pet Sitter": "Pet Sitter",
            "Pet Store": "Pet",
            "Pet Trainer": "Pet Trainer",
            "Pet Walker": "Pet Walker",
            "Veterinarian": "Veterinarian"
        }
    },
    "Professional Services": {
        "label": "Professional Services",
        "display": true,
        "types": {
            "Accountant or CPA": "Accountant CPA",
            "Architect or Architecture Firm": "Architect",
            "Employment or Staffing Agency": "Employment Staffing",
            "Find or Change Job": "Find Change Job",
            "Graphic Designer": "Graphic Designer",
            "Insurance Agency": "Insurance",
            "Internet or SEO Marketing Firm": "Internet SEO Marketing",
            "Legal Firm or Attorney": "Legal Attorney",
            "Life Coach": "Life Coach",
            "Private Investigator": "Private Investigator",
            "Professional Development Provider": "Professional Development",
            "Tax Advisor": "Tax Advisor",
            "Telecommunications Provider": "Telecommunications",
            "Web Designer": "Web Designer"
        }
    },
    "Real Estate": {
        "label": "Real Estate",
        "display": true,
        "types": {
            "Apartment Rental Agency": "Apartment Rental",
            "Home Inspector": "Home Inspector",
            "Home Staging Company": "Home Staging",
            "Log Home Builder": "Log Home Builder",
            "Manufactured or Modular Home Builder": "Manufactured Modular Home Builder",
            "Mortgage Broker": "Mortgage Broker",
            "Property Manager": "Property Manager",
            "Real Estate Appraiser": "Real Estate Appraiser",
            "Real Estate Brokerage Firm": "Real Estate Brokerage",
            "Realtor": "Realtor",
            "Title & Escrow Company": "Title Escrow",
            "University Housing": "University Housing"
        }
    },
    "Recreation": {
        "label": "Recreation",
        "display": true,
        "types": {
            "Archery Range": "Archery Range",
            "Bait & Tackle Shop": "Bait Tackle",
            "Bicycle Shop": "Bicycle",
            "Bike Rental Shop": "Bike Rental",
            "Billiard Supply Store": "Billiard Supply",
            "Boat Dealer": "Boat Dealer",
            "Bowling Alley": "Bowling Alley",
            "Dive Shop": "Dive",
            "Equine Supply Store or Tack Shop": "Equine Supply Tack",
            "Fishing Supply Store": "Fishing Supply",
            "Golf Course": "Golf Course",
            "Golf Driving Range": "Golf Driving Range",
            "Golf Pro Shop": "Golf Pro",
            "Gun Shooting Range": "Gun Shooting Range",
            "Gun Store": "Gun",
            "Miniature Golf Course": "Miniature Golf Course",
            "Outdoor Gear Store": "Outdoor Gear",
            "Skate Shop": "Skate",
            "Ski Shop": "Ski",
            "Sporting Goods Store": "Sporting Goods",
            "Taxidermist": "Taxidermist",
            "Used Sporting Goods Store": "Used Sporting Goods "
        }
    },
    "Restaurant / Bar / Lounge": {
        "label": "Restaurant / Bar / Lounge",
        "display": true,
        "types": {
            "Brewery or Brew Pub": "Brewery or Brew Pub",
            "Buffet Restaurant": "Buffet Restaurant",
            "Family Style Restaurant": "Family Style Restaurant",
            "Fast Food Restaurant": "Fast Food Restaurant",
            "Fine Dining Restaurant": "Fine Dining Restaurant",
            "Restaurant with Lounge or Bar": "Restaurant Lounge Bar"
        }
    },
    "Service Providers": {
        "label": "Service Providers",
        "display": true,
        "types": {
            "Accountant": "Accountant",
            "Bank": "Bank",
            "Cable Service Provider": "Cable Provider",
            "Cellular Phone Provider": "Cellular Phone Provider",
            "Computer Services": "Computer s",
            "Credit Union": "Credit Union",
            "Financial Planner": "Financial Planner",
            "Florist": "Florist",
            "Hospice Provider": "Hospice Provider",
            "IT Services & Networking": "IT Information Services Networking",
            "Insurance Agent": "Insurance Agent",
            "Interior Designer": "Interior Designer",
            "Internet Service Provider": "Internet Provider",
            "Mortgage Banker": "Mortgage Banker",
            "Mortgage Broker": "Mortgage Broker",
            "Notary Public": "Notary Public",
            "Personal Services": "Personal Services",
            "Phone Service Provider": "Phone Provider",
            "Retirement Home": "Retirement Home",
            "Retirement or Financial Planning Service": "Retirement Financial Planning",
            "Satellite Service Provider": "Satellite Provider",
            "Senior Housing": "Senior Housing",
            "Switch to Co-op for Electricity": "Co-op Electricity",
            "Tax Advisor or Service": "Tax Advisor",
            "Telecommunications Provider": "Telecommunications Provider",
            "Wedding Planner": "Wedding Planner"
        }
    },
    "Specialty Food and Drink": {
        "label": "Specialty Food and Drink",
        "display": true,
        "types": {
            "Bagel Shop": "Bagel",
            "Bakery": "Bakery",
            "Beer Shop": "Beer",
            "Beverage Distributor": "Beverage Distributor",
            "Candy Store": "Candy",
            "Cheese Shop": "Cheese",
            "Chocolate Shop": "Chocolate",
            "Coffee & Tea Shop": "Coffee Tea",
            "Condiment Shop": "Condiment",
            "Convenience Store": "Convenience",
            "Cookie Store": "Cookie",
            "Cooking Supply Store": "Cooking Supply",
            "Cupcake Shop": "Cupcake",
            "Dessert Restaurant": "Dessert Restaurant",
            "Distillery": "Distillery",
            "Donut Shop": "Donut",
            "Espresso Cart or Stand": "Espresso Cart",
            "Espresso or Coffee Shop": "Espresso Coffee",
            "Ethnic Food Restaurant": "Ethnic Food Restaurant",
            "Food Cart or Truck": "Food Cart Truck",
            "Fruit and Vegetable Store": "Fruit and Vegetable",
            "Grocery Delivery Service": "Grocery Delivery",
            "Grocery Store (Discount)": "Grocery (Discount)",
            "Grocery Store (Ethnic)": "Grocery (Ethnic)",
            "Grocery Store (Independent)": "Grocery (Independent)",
            "Grocery Store (Major or Regional Chain)": "Grocery (Regional)",
            "Ice Cream or Frozen Yogurt Shop": "Ice Cream  Frozen Yogurt",
            "Liquor Store": "Liquor",
            "Meat Market or Butcher Shop": "Meat Market Butcher",
            "Seafood Market": "Seafood Market",
            "Smoothie or Juice Bar": "Smoothie Juice Bar",
            "Specialty Cake Bakery": "Specialty Cake Bakery",
            "Specialty Food Market": "Specialty Food Market",
            "Spice Shop": "Spice",
            "Tea Shop": "Tea",
            "U-Brew Beer or Wine Store": "Brew Beer Wine",
            "Wine Shop": "Wine",
            "Winery": "Winery"
        }
    }
};

export {defaultCategories};